import { buildSelector } from '@/shared/lib/store';

export const [useViewerPhone] = buildSelector(
    (state) => state.viewer?.data?.phone,
);
